import { LicenseInfo } from '@mui/x-license';

LicenseInfo.setLicenseKey(
  '14362c43068155da7b702d40dacb7381Tz0xMjkwNzUsRT0xODA5OTA3MTk5MDAwLFM9cHJvLExNPXBlcnBldHVhbCxQVj1RMS0yMDI2LFE9MSxBVD1tdWx0aSxLVj0y'
);

const MuiXLicense: React.FC = () => null;

export default MuiXLicense;
